import { Prisma } from '@prisma/client';
import axiosInstance from '../api';

const addendumsService = {
  create: async (data: Prisma.addendumsCreateInput): Promise<any> => {
    const response = await axiosInstance.post('/addendums', data);
    return response.data;
  },
  patch: async (
    id: string,
    data: Prisma.addendumsUpdateInput
  ): Promise<any> => {
    const response = await axiosInstance.patch(`/addendums/${id}`, data);
    return response.data;
  },
  put: async (id: string, data: Prisma.addendumsUpdateInput): Promise<any> => {
    const response = await axiosInstance.put(`/addendums/${id}`, data);
    return response.data;
  },
};

export default addendumsService;
